import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_SystemSettings = _resolveComponent("SystemSettings")!
  const _component_PosReceiptSettings = _resolveComponent("PosReceiptSettings")!
  const _component_PaymentGateway = _resolveComponent("PaymentGateway")!
  const _component_SMSConfiguration = _resolveComponent("SMSConfiguration")!
  const _component_SMTPConfiguration = _resolveComponent("SMTPConfiguration")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, { pageTitle: "System Settings" }),
      _createVNode(_component_SystemSettings),
      _createVNode(_component_PosReceiptSettings),
      _createVNode(_component_PaymentGateway),
      _createVNode(_component_SMSConfiguration),
      _createVNode(_component_SMTPConfiguration),
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"card border-0 shadow-none rounded-1 mb-40\"><div class=\"card-body p-xl-40\"><h6 class=\"fs-18 mb-35 text-title fw-semibold\">Clear Cache</h6><button type=\"button\" class=\"btn style-five\">Change Settings</button></div></div><div class=\"flex-grow-1\"></div>", 2)),
      _createVNode(_component_MainFooter)
    ])
  ], 64))
}